// eslint-disable-next-line import/prefer-default-export
export const statusColors = {
  revise: {
    submit: '#AED6F1',
    prequalification: '#5DADE2',
    specialization: '#3498D8',
    finance: '#2E86C1',
    approved: '#2874A6',
    notQualified: '#E74C3C',
  },

  submit: {
    ongoingProject: '#2874A6',
    midtermQualifiedProject: '#239B56',
    midtermNotQualifiedProject: '#CB4335',
    acceptanceQualifiedProject: '#1D8348',
    acceptanceNotQualifiedProject: '#943126',
    overdueProject: '#FFA64D',
  },
};
